import { NgClass } from '@angular/common';
import { AfterViewInit, Component, OnInit, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RaxBFF } from '@raxapi/booker.planner.bff.api';
import { BffApiBusyService } from '@raxapp/booker-backend-apis/bff-api-busy.service';
import { UserAccountService } from '@raxapp/user-accounts/user-account.service';
import { SharedCacheService } from '@raxshared/cache.service';
import { environment } from 'src/environments/environment';
import { EnvType } from '../../../../environments/iEnvironment';
import { ShowErrorPageService } from './show-error-page.service';

@Component({
    selector: 'rax-error-page',
    templateUrl: './error-page.component.html',
    imports: [MatButtonModule, NgClass],
})
export class ErrorPage implements OnInit, AfterViewInit {
    private readonly cacheService = inject(SharedCacheService);
    private readonly bffApiBusyService = inject(BffApiBusyService);
    private readonly showErrorPageService = inject(ShowErrorPageService);
    private readonly userAccountService = inject(UserAccountService);

    public readonly showErrorDetails = signal(false);
    private readonly isProduction = environment.envName === EnvType.prod;

    private readonly exceptionViewCacheKey = 'exceptionView';
    public readonly exceptionView = this.showErrorPageService.exceptionView;

    public ngOnInit(): void {
        if (this.exceptionView() != undefined) {
            this.cacheService.addLocal<RaxBFF.Result>(this.exceptionViewCacheKey, this.exceptionView()!);
        } else {
            this.exceptionView.set(this.cacheService.getLocal<RaxBFF.Result>(this.exceptionViewCacheKey));
            if (this.exceptionView() == undefined) {
                this.exceptionView.set({
                    success: false,
                    reason: 'Unknown*',
                    isException: false,
                });
            }
        }

        if (this.isProduction) {
            this.showErrorDetails.set(false);
        }

        if (this.userAccountService.isSysAdmin()) {
            this.showErrorDetails.set(true);
        }
    }

    public ngAfterViewInit(): void {
        this.bffApiBusyService.clear();
    }

    public onGoHomeButtonClick(): void {
        this.cacheService.removeLocal(this.exceptionViewCacheKey);
        this.exceptionView.set(undefined);

        window.location.href = window.location.origin;
    }

    public onToggleShowErrorDetailsButtonClick(): void {
        this.showErrorDetails.set(!this.showErrorDetails());
    }
}
